module.exports = __webpack_public_path__ + "static/img/publicar1680x1050.773e125.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/landing/empleador/publicar/publicar1680x1050.jpg
// module id = jLoh
// module chunks = 47